<div class="dx-field-label">Dark Mode</div>
<div class="dx-field-value" style="width: auto !important;">
  <dx-switch [value]="isDarkTheme" [hint]="'Dark Mode'" (onValueChanged)="toggleChange($event)"></dx-switch>
</div>
